import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { dialogInfoAtom } from '../atoms'
import { type BrandAccountUser } from '../hooks'

export type DeleteButtonProps = {
  dataItem: BrandAccountUser
}

export const DeleteButton = ({
  dataItem: brandAccountUser,
}: DeleteButtonProps) => {
  const { t } = useTranslation()
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleDeleteButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ brandAccountUser, dialogType: 'delete' })
  }, [brandAccountUser, setDialogInfo])

  return (
    <StyledButton
      buttonStyle="alert"
      fillMode="outline"
      icon="delete"
      onClick={handleDeleteButtonClick}
    >
      {t('delete')}
    </StyledButton>
  )
}
